import React from "react";

export function mmToInches(mm) {
  console.log(mm);
  try {
    if (typeof mm !== "number" || isNaN(mm)) {
      throw new Error("mmToInches expects a valid number");
    }
    const valuue = mm / 25.4;
    return valuue.toFixed(2); // 1 inch = 25.4 mm
  } catch (error) {
    console.log(error);
  }
}

export function sqMmToSqFt(sqMm) {
  if (typeof sqMm !== "number" || isNaN(sqMm)) {
    throw new Error("sqMmToSqFt expects a valid number");
  }

  // 1 ft² = 92903.04 mm²
  const sqFt = sqMm / 92903.04;
  return sqFt.toFixed(2);
}

export function areaToSqFt(area, lengthUnit) {
  if (typeof area !== "number" || isNaN(area)) {
    console.log("areaError");
    return 0;
  }

  let sqFt = 0;

  if (lengthUnit === "mm") {
    sqFt = area / 92903.04; // Convert mm² to ft²
  } else if (lengthUnit === "Inch") {
    sqFt = area / 144; // Convert in² to ft²
  } else {
    return 0; // Invalid unit
  }

  return sqFt.toFixed(2);
}

function DisplayInches({ mmValue }) {
  let inchValue = 0;
  try {
    inchValue = mmToInches(mmValue);
  } catch (error) {
    console.error(error);
  }

  return (
    <div>
      <p>
        {mmValue} mm = {inchValue.toFixed(2)}
      </p>
    </div>
  );
}

export default DisplayInches;
